export const checkOtpValid=(val:string)=>{
    return val.length==6

}